<!--
 * @Description: 班干部会议记录 添加
 * @Author: ztw
 * @Date: 2023-03-01 17:51:17.213
 * @LastEditors: 张天伟
 * @LastEditTime: 2023-03-02 18:32:51
-->
<template>
  <div>
    <el-dialog class="w800 h630" :model-value="openAdd" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Edit />
          </el-icon>
          <span class="header-title">添加</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="closeWindow('openAdd', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <el-form ref="ruleFormRef" :model="ruleForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item label="学期" prop="xqid" :rules="[{ required: true, message: '必填项', trigger: 'blur' }]">
              <el-select v-model="ruleForm.xqid" clearable filterable >
                <el-option v-for="item in allXq" :key="item.id" :label="item.xqmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="班级" prop="bjid" >
              <el-select v-model="ruleForm.bjid" clearable filterable >
                <el-option v-for="item in banjilist" :key="item.id" :label="item.xzbmc" :value="item.id" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="主持人" prop="zcr" >
              <el-input v-model="ruleForm.zcr" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="时间" prop="sj" >
              <el-date-picker v-model="ruleForm.sj" type="datetime" format="YYYY-MM-DD HH:mm" value-format="YYYY-MM-DD HH:mm" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="参加人数" prop="cjrs" >
              <el-input-number v-model="ruleForm.cjrs" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="缺席人数" prop="qxrs" >
              <el-input-number v-model="ruleForm.qxrs" :min="0" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="会议地址" prop="hydz" >
              <el-input v-model="ruleForm.hydz" />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="会议记录" prop="hyjl" >
              <el-input v-model="ruleForm.hyjl" type="textarea" resize="none"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <div></div>
          <div class="footer_but">
            <el-button type="primary" @click="submit()">保存</el-button>
            <el-button type="info" @click="closeWindow('openAdd', emits, false)">关闭</el-button>
          </div>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, defineEmits, ref, watch, unref } from 'vue'
import { submitForm, closeWindow } from '@/api/common.js'
import { getxueqiList } from '@/api/publicApi'
import { chaxvnbanji } from '@/api/home.js'
const props = defineProps({ openAdd: { type: Boolean, required: true } })
const emits = defineEmits(['update:openAdd', 'ReturnData'])
const ruleFormRef = ref(null)
const ruleForm = ref({})
const allXq = ref([]) // 学期
const banjilist = ref() // 班级数据
const initSelectList = async () => {
  getxueqiList().then((res) => {
    allXq.value = res.data
    res.data.forEach((element) => {
      if (element.sfdqxq) {
        ruleForm.value.xqid = element.id
        getdengluren()
      }
    })
  })
}

const getdengluren = () => {
  chaxvnbanji().then(res => {
    banjilist.value = res.data
    banjiid.value = res.data[0].id
    getbanjixveshenglist()
  })
}

watch(
  () => props.openAdd,
  () => {
    if (props.openAdd) {
      initSelectList()
    }
  },
  { deep: true, immediate: true }
)

// 提交
const submit = async () => {
  submitForm({
    url: '/api/v2/xuesheng/banzhurengongzuobanganbuhuiyijilu',
    ruleFormRef: unref(ruleFormRef),
    ruleForm: ruleForm.value,
    callback: function () {
      closeWindow('openAdd', emits, true)
    }
  })
}
</script>
